// extracted by mini-css-extract-plugin
export default {"row":"row__1Rt2C","content":"content__EpV2R","title":"title__tuo8F","subtitle":"subtitle__EiKfX","error-subtitle":"error-subtitle__e0Uod","icon":"icon__9JxbW"};